// extracted by mini-css-extract-plugin
export default {"inboxes":"inboxes--pQJLO","inboxes-ListItem":"inboxes-ListItem--RJTXH","treePlaceholder":"treePlaceholder--MUFsi","inboxesTree":"inboxesTree--dLTmi"};